module.exports = __webpack_public_path__ + "static/media/Brookside-Bylaws-Livonia.3d65c05b.pdf";